import { render, staticRenderFns } from "./MainItem.vue?vue&type=template&id=45cd32f4&"
import script from "./MainItem.vue?vue&type=script&lang=js&"
export * from "./MainItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports